<template>
  <div class="invoice-container">
    <nav class="add-navigation">
      <!-- <search-input class="search-input"
                    type="text"
                    v-model="SearchUser"
      placeholder="Search for user" />-->
      <primary-button
        @click.native="$router.push({name: 'company-admin-campaings-import-ani-group'})"
        class="primary-button"
      >Import</primary-button>
      <div class="primary-button">
        <primary-button
          @click.native="$router.push({name: 'company-admin-campaings-add-ani-group'})"
        >Add Ani Group</primary-button>
      </div>
    </nav>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th>Ani Group Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="line" v-for="(aniGroup, k) in aniGroups" :key="k">
          <th>{{aniGroup.aniGroupName}}</th>
          <!-- <th class="creadted_by"><img class="popup_image" src="@/assets/person.jpg" alt="">{{payment.createdBy}}</th> 
            <th class="method">{{payment.method}}</th>
          <th class="Invoice_price">${{payment.amount}}</th>-->
          <th class="icon-right">
            <img
              @click="$router.push({name: 'company-admin-campaings-edit-ani-group', params: {id: aniGroup.aniGroupId}})"
              src="@/assets/Icon/Edit.svg"
              alt
            />
            <img @click="deleteAniGroup(aniGroup.aniGroupId)" src="@/assets/Icon/Delete.svg" alt />
          </th>
        </tr>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :perPage="PerPage"
        :total="TotalPages"
        :qnt="aniGroups.length"
      />
      <!-- <secondary-button @click.native="prev" class="secondary-button">Prev</secondary-button>
      <secondary-button @click.native="next" class="secondary-button">Next</secondary-button>-->
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    showDropDown: false,
    aniGroups: [],
    PerPage: null,
    Total: null,
    Searched: "",
    Page: 0,
    TotalPages: null
  }),
  computed: {},
  created() {
    this.GetList(this.Searched, this.Page);
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList(search, page) {
      this.$store
        .dispatch("GetAniList", {
          search: search,
          page: page
        })
        .then(res => {
          console.log("res from GetAniList--->", res);
          this.aniGroups = res.items.map(this.transformAniGroups);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformAniGroups(i, k) {
      return {
        aniGroupName: i.ani_group_name,
        aniGroupId: i.ani_group_uuid
      };
    },
    outside() {
      this.showDropDown = false;
    },
    next() {
      let count = this.Total - this.PerPage * this.Page;
      if (count > this.PerPage) {
        this.Page++;
        this.GetList(this.Searched, this.Page);
      }
    },
    prev() {
      if (this.Page !== 0) {
        this.Page--;
        console.log("page", this.Page);
        this.GetList(this.Searched, this.Page);
      }
    },
    deleteAniGroup(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this ani group!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteUser", id)
            .then(res => {
              console.log("res--->", res);
              this.getUsersList();
              this.$swal("Deleted!", "Ani Group has been deleted.", "success");
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-container {
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: fit-content;
    float: right;
    margin-top: 20px;
    margin-bottom: 20px;
    .search-input {
      height: 40px;
      width: 345px;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 120px;
      margin-left: 20px;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    margin-top: 20px;
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;
}
table thead tr {
  height: 37px;
  background: #f8f9fe;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 50px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 15px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  float: right;
  width: 75px;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  padding: 10px 15px 10px 0;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
  text-align: left;
}
tbody th.icon-right {
  display: flex;
  color: #55616e;
  float: right;
  img {
    width: 30px;
    height: 30px;
    margin-right: 15px;
  }
}
table th:first-child {
  padding-left: 15px;
}
tbody th.creadted_by {
  padding: 10px 0 10px 0;
}
tbody th.method {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
  height: 25px;
  padding: 13px 0 12px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
</style>

